module.exports = __webpack_public_path__ + "5ca8c961ed309bfbc2901c03f2428ede.pdf";